import { render, staticRenderFns } from "./PurchaseDetails.vue?vue&type=template&id=cefd3c4a&lang=pug"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports